// extracted by mini-css-extract-plugin
module.exports = {"container":"atdM0","title":"g7WTU","icon":"SiL4c","info":"MV1Em"};